module.exports = __webpack_public_path__ + "img/mkt.2c0fc32b.png";